import React from 'react';
import '../template-file-css/document-file-template.css';


export const ATC_SubstanceAbuseChild = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ATC_SubstanceAbuseChild' className='file-pdf-document'>
            <div className='file-template'>



                <table>
                    <tr>
                        <th className='w-40'><span className='eleHeader'>&nbsp;</span>  </th>
                        <th className='w-30'> <span className='eleHeader'>T</span>  </th>
                        <th className='w-30'><span className='eleHeader'>F</span>  </th>
                        <th className='w-650'><span className='eleHeader'>&nbsp;</span>  </th>
                    </tr>
                    <tr>
                        <td className='w-40'>(1)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ1" className='add-only' id='rbQ1_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ1" className='add-only' id='rbQ1_False' value="False" />
                        </td>
                        <td>
                            People will probably succeed if they work hard.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(2) </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ2" className='add-only' id='rbQ2_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ2" className='add-only' id='rbQ2_False' value="False" />
                        </td>
                        <td>
                            At least one of my parents has often been very sad, anxious, or unhappy.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(3)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ3" className='add-only' id='rbQ3_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ3" className='add-only' id='rbQ3_False' value="False" />
                        </td>
                        <td>
                            I have never been in trouble with the principal or the police.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(4)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ4" className='add-only' id='rbQ4_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ4" className='add-only' id='rbQ4_False' value="False" />
                        </td>
                        <td>
                            I can be friendly with people who do many wrong things.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(5)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ5" className='add-only' id='rbQ5_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ5" className='add-only' id='rbQ5_False' value="False" />
                        </td>
                        <td>
                            I do not like to sit and daydream.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(6)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ6" className='add-only' id='rbQ6_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ6" className='add-only' id='rbQ6_False' value="False" />
                        </td>
                        <td>
                            The school rules regarding getting caught with drugs are too strict.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(7)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ7" className='add-only' id='rbQ7_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ7" className='add-only' id='rbQ7_False' value="False" />
                        </td>
                        <td>
                            Sometimes I have a hard time sitting still.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(8)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ8" className='add-only' id='rbQ8_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ8" className='add-only' id='rbQ8_False' value="False" />
                        </td>
                        <td>
                            I have not lived the way I should.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(9)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ9" className='add-only' id='rbQ9_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ9" className='add-only' id='rbQ9_False' value="False" />
                        </td>
                        <td>
                            I have had days, weeks, or months when I couldn't get much done because I just wasn't
                            up to it.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(10)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ10" className='add-only' id='rbQ10_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ10" className='add-only' id='rbQ10_False' value="False" />
                        </td>
                        <td>
                            I always listen carefully to people who are older than me.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(11)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ11" className='add-only' id='rbQ11_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ11" className='add-only' id='rbQ11_False' value="False" />
                        </td>
                        <td>
                            I like to obey the rules.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(12)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ12" className='add-only' id='rbQ12_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ12" className='add-only' id='rbQ12_False' value="False" />
                        </td>
                        <td>
                            I have often felt bad or scared because of the drinking or drug use of someone in
                            my family.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(13)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ13" className='add-only' id='rbQ13_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ13" className='add-only' id='rbQ13_False' value="False" />
                        </td>
                        <td>
                            Some crooks are so clever that I hope they don't get caught.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(14)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ14" className='add-only' id='rbQ14_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ14" className='add-only' id='rbQ14_False' value="False" />
                        </td>
                        <td>
                            I have never done anything dangerous just for fun.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(15)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ15" className='add-only' id='rbQ15_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ15" className='add-only' id='rbQ15_False' value="False" />
                        </td>
                        <td>
                            I am always well behaved in school.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(16)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ16" className='add-only' id='rbQ16_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ16" className='add-only' id='rbQ16_False' value="False" />
                        </td>
                        <td>
                            I have sometimes drunk too much beer or other alcoholic drink.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(17)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ17" className='add-only' id='rbQ17_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ17" className='add-only' id='rbQ17_False' value="False" />
                        </td>
                        <td>
                            Sometimes I wish I had better control of how I behave and feel.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(18)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ18" className='add-only' id='rbQ18_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ18" className='add-only' id='rbQ18_False' value="False" />
                        </td>
                        <td>
                            Adults shouldn't hassle kids so much about drugs.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(19)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ19" className='add-only' id='rbQ19_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ19" className='add-only' id='rbQ19_False' value="False" />
                        </td>
                        <td>
                            I break more rules than most people my age.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(20)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ20" className='add-only' id='rbQ20_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ20" className='add-only' id='rbQ20_False' value="False" />
                        </td>
                        <td>
                            Swearing and cursing have become a serious problem in our schools and must be stopped.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(21)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ21" className='add-only' id='rbQ21_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ21" className='add-only' id='rbQ21_False' value="False" />
                        </td>
                        <td>
                            I'm friends with some people who sell drugs.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(22)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ22" className='add-only' id='rbQ22_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ22" className='add-only' id='rbQ22_False' value="False" />
                        </td>
                        <td>
                            I am usually happy.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(23)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ23" className='add-only' id='rbQ23_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ23" className='add-only' id='rbQ23_False' value="False" />
                        </td>
                        <td>
                            I have been tempted to hit someone.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(24)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ24" className='add-only' id='rbQ24_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ24" className='add-only' id='rbQ24_False' value="False" />
                        </td>
                        <td>
                            I always feel sure of myself.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(25)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ25" className='add-only' id='rbQ25_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ25" className='add-only' id='rbQ25_False' value="False" />
                        </td>
                        <td>
                            My school teachers have had some problems with me.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(26)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ26" className='add-only' id='rbQ26_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ26" className='add-only' id='rbQ26_False' value="False" />
                        </td>
                        <td>
                            Many of my friends drink or get high regularly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(27)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ27" className='add-only' id='rbQ27_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ27" className='add-only' id='rbQ27_False' value="False" />
                        </td>
                        <td>
                            I have never broken an important rule.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(28)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ28" className='add-only' id='rbQ28_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ28" className='add-only' id='rbQ28_False' value="False" />
                        </td>
                        <td>
                            There have been times when I have done things that I don't remember.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(29)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ29" className='add-only' id='rbQ29_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ29" className='add-only' id='rbQ29_False' value="False" />
                        </td>
                        <td>
                            Getting caught drinking or using drugs is no big deal.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(30)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ30" className='add-only' id='rbQ30_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ30" className='add-only' id='rbQ30_False' value="False" />
                        </td>
                        <td>
                            I think carefully about everything I do.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(31)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ31" className='add-only' id='rbQ31_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ31" className='add-only' id='rbQ31_False' value="False" />
                        </td>
                        <td>
                            I have used alcohol or "pot" too much or too often.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(32)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ32" className='add-only' id='rbQ32_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ32" className='add-only' id='rbQ32_False' value="False" />
                        </td>
                        <td>
                            Some of my friends have bad reputations.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(33)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ33" className='add-only' id='rbQ33_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ33" className='add-only' id='rbQ33_False' value="False" />
                        </td>
                        <td>
                            I smoke cigarettes regularly.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(34)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ34" className='add-only' id='rbQ34_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ34" className='add-only' id='rbQ34_False' value="False" />
                        </td>
                        <td>
                            At times, I have been so full of energy that I felt I didn't need to sleep for days
                            at a time.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(35)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ35" className='add-only' id='rbQ35_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ35" className='add-only' id='rbQ35_False' value="False" />
                        </td>
                        <td>
                            Adults don't really know how much teenagers are using drugs.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(36)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ36" className='add-only' id='rbQ36_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ36" className='add-only' id='rbQ36_False' value="False" />
                        </td>
                        <td>
                            I have never felt sad over anything.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(37)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ37" className='add-only' id='rbQ37_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ37" className='add-only' id='rbQ37_False' value="False" />
                        </td>
                        <td>
                            I think there is something wrong with my memory.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(38)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ38" className='add-only' id='rbQ38_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ38" className='add-only' id='rbQ38_False' value="False" />
                        </td>
                        <td>
                            I have neglected schoolwork because of my drinking or drug use.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(39)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ39" className='add-only' id='rbQ39_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ39" className='add-only' id='rbQ39_False' value="False" />
                        </td>
                        <td>
                            I have taken a drink in the morning to steady my nerves or to get rid of a hangover.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(40)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ40" className='add-only' id='rbQ40_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ40" className='add-only' id='rbQ40_False' value="False" />
                        </td>
                        <td>
                            I often daydream about things that I don't tell other people.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(41)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ41" className='add-only' id='rbQ41_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ41" className='add-only' id='rbQ41_False' value="False" />
                        </td>
                        <td>
                            I have wanted to run away from home.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(42)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ42" className='add-only' id='rbQ42_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ42" className='add-only' id='rbQ42_False' value="False" />
                        </td>
                        <td>
                            people who use drugs have more fun.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(43)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ43" className='add-only' id='rbQ43_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ43" className='add-only' id='rbQ43_False' value="False" />
                        </td>
                        <td>
                            I like doing things with my family.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(44)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ44" className='add-only' id='rbQ44_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ44" className='add-only' id='rbQ44_False' value="False" />
                        </td>
                        <td>
                            It doesn't really bother me to see animals suffer.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(45)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ45" className='add-only' id='rbQ45_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ45" className='add-only' id='rbQ45_False' value="False" />
                        </td>
                        <td>
                            At times I feel worn out for no reason at all.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(46)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ46" className='add-only' id='rbQ46_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ46" className='add-only' id='rbQ46_False' value="False" />
                        </td>
                        <td>
                            I can see why they have laws about drugs like cocaine and heroin but outlawing marijuana
                            is stupid.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(47)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ47" className='add-only' id='rbQ47_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ47" className='add-only' id='rbQ47_False' value="False" />
                        </td>
                        <td>
                            No one has ever criticized or punished me.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(48)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ48" className='add-only' id='rbQ48_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ48" className='add-only' id='rbQ48_False' value="False" />
                        </td>
                        <td>
                            I think carefully about how I dress.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(49)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ49" className='add-only' id='rbQ49_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ49" className='add-only' id='rbQ49_False' value="False" />
                        </td>
                        <td>
                            My drinking or other drug use causes problems between me and my family.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(50)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ50" className='add-only' id='rbQ50_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ50" className='add-only' id='rbQ50_False' value="False" />
                        </td>
                        <td>
                            I have skipped school pretty often.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(51)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ51" className='add-only' id='rbQ51_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ51" className='add-only' id='rbQ51_False' value="False" />
                        </td>
                        <td>
                            Most of the people my age drink or use drugs.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(52)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ52" className='add-only' id='rbQ52_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ52" className='add-only' id='rbQ52_False' value="False" />
                        </td>
                        <td>
                            Sometimes I like doing the opposite of others want.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(53)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ53" className='add-only' id='rbQ53_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ53" className='add-only' id='rbQ53_False' value="False" />
                        </td>
                        <td>
                            My parents like my friends.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(54)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ54" className='add-only' id='rbQ54_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ54" className='add-only' id='rbQ54_False' value="False" />
                        </td>
                        <td>
                            In new situations, I like to find out which people it would be useful to be friendly
                            with.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(55)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ55" className='add-only' id='rbQ55_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ55" className='add-only' id='rbQ56_False' value="False" />
                        </td>
                        <td>
                            One of my parents was/is a heavy drinker or drug user.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(56)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ56" className='add-only' id='rbQ56_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ56" className='add-only' id='rbQ56_False' value="False" />
                        </td>
                        <td>
                            In school, I have often been in trouble for misbehaving.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(57)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ57" className='add-only' id='rbQ57_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ57" className='add-only' id='rbQ57_False' value="False" />
                        </td>
                        <td>
                            More often than not, I have a sense that life is worthwhile.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(58)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ58" className='add-only' id='rbQ58_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ58" className='add-only' id='rbQ58_False' value="False" />
                        </td>
                        <td>
                            I have used alcohol to excess.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(59)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ59" className='add-only' id='rbQ59_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ59" className='add-only' id='rbQ59_False' value="False" />
                        </td>
                        <td>
                            When I'm in a group, I have trouble thinking of the right things to talk about.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(60)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ60" className='add-only' id='rbQ60_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ60" className='add-only' id='rbQ60_False' value="False" />
                        </td>
                        <td>
                            Drugs help people to be creative.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(61)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ61" className='add-only' id='rbQ61_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ61" className='add-only' id='rbQ61_False' value="False" />
                        </td>
                        <td>
                            My grades in school are average or better.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(62)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ62" className='add-only' id='rbQ61_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ62" className='add-only' id='rbQ62_False' value="False" />
                        </td>
                        <td>
                            I don't really worry about catching diseases.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(63)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ63" className='add-only' id='rbQ63_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ63" className='add-only' id='rbQ63_False' value="False" />
                        </td>
                        <td>
                            Sometimes I feel that my drug use or drinking is keeping me from getting what I
                            want out of life.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(64)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ64" className='add-only' id='rbQ64_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ64" className='add-only' id='rbQ64_False' value="False" />
                        </td>
                        <td>
                            I've frequently played sick to get out of something.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(65)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ65" className='add-only' id='rbQ65_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ65" className='add-only' id='rbQ65_False' value="False" />
                        </td>
                        <td>
                            I think many adults who say they are against drugs probably use some kind of drugs
                            themselves.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(66)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ66" className='add-only' id='rbQ66_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ66" className='add-only' id='rbQ66_False' value="False" />
                        </td>
                        <td>
                            My parents hardly ever know where I am.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(67)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ67" className='add-only' id='rbQ67_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ67" className='add-only' id='rbQ67_False' value="False" />
                        </td>
                        <td>
                            My participation in clubs, sports, or other after school activities is important
                            in my life.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(68)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ68" className='add-only' id='rbQ68_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ68" className='add-only' id='rbQ68_False' value="False" />
                        </td>
                        <td>
                            I am often resless or jumpy.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(69)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ69" className='add-only' id='rbQ69_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ69" className='add-only' id='rbQ69_False' value="False" />
                        </td>
                        <td>
                            I have sometimes just sat about when I should have been working.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(70)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ70" className='add-only' id='rbQ70_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ70" className='add-only' id='rbQ70_False' value="False" />
                        </td>
                        <td>
                            The drug laws we have are stupid.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(71)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ71" className='add-only' id='rbQ71_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ71" className='add-only' id='rbQ71_False' value="False" />
                        </td>
                        <td>
                            If some friends and I were in trouble together, I would rather take the whole blame
                            than tell on them.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-40'>(72)
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ72" className='add-only' id='rbQ72_True' value="True" />
                        </td>
                        <td className='w-30'>
                            <input type="radio" name="rbQ72" className='add-only' id='rbQ72_False' value="False" />
                        </td>
                        <td>
                            I can be depended on to do the things I am supposed to do.
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> For each item below, select the number which reflects how often you have experienced
                            the situation during:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="radio" name="rbExperienceTimeSpan" className='add-only' value="Your Entire Life" /> Your Entire Life</td>
                        <td className='w-375'> <input type="radio" name="rbExperienceTimeSpan" className='add-only' value="The Past 6 Months" /> The Past 6 MOnths</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="radio" name="rbExperienceTimeSpan" className='add-only' value="The 6 Months Before" /> The 6 Months Before:</td>
                        <td className='w-375'> <input type="radio" name="rbExperienceTimeSpan" className='add-only' value="The 6 Months After" /> The 6 Months After:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type="text" id="txtSixMonthsBefore" name="txtSixMonthsBefore" className='add-only' /></td>
                        <td className='w-375'> <input type="text" id="txtSixMonthsAfter" name="txtSixMonthsAfter" className='add-only' /></td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>ALCOHOL (FVA)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>(1) Drank alcohol during the day? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ1" id='rbAlcoholQ1_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ1" id='rbAlcoholQ1_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ1" id='rbAlcoholQ1_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ1" id='rbAlcoholQ1_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(2) Taken a drink or drinks to help you express your feelings or ideas? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ2" id='rbAlcoholQ2_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ2" id='rbAlcoholQ2_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ2" id='rbAlcoholQ2_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ2" id='rbAlcoholQ2_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(3) Taken a drink or drinks to relieve a tired feeling or give you energy to keep going? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ3" id='rbAlcoholQ3_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ3" id='rbAlcoholQ3_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ3" id='rbAlcoholQ3_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ3" id='rbAlcoholQ3_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(4) Had more to drink than you intended to? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ4" id='rbAlcoholQ4_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ4" id='rbAlcoholQ4_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ4" id='rbAlcoholQ4_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ4" id='rbAlcoholQ4_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(5) Gotten sick from drinking (e.g. vomiting, dizziness, headache)? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ5" id='rbAlcoholQ5_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ5" id='rbAlcoholQ5_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ5" id='rbAlcoholQ5_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ5" id='rbAlcoholQ5_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(6) Gotten into trouble on the job, with the police, in school or at home because of drinking? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ6" id='rbAlcoholQ6_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ6" id='rbAlcoholQ6_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ6" id='rbAlcoholQ6_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ6" id='rbAlcoholQ6_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(7) Become very sad or felt "down" after having sobered up? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ7" id='rbAlcoholQ7_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ7" id='rbAlcoholQ7_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ7" id='rbAlcoholQ7_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ7" id='rbAlcoholQ7_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(8) Argued with your family or friends because of your drinking? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ8" id='rbAlcoholQ8_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ8" id='rbAlcoholQ8_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ8" id='rbAlcoholQ8_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ8" id='rbAlcoholQ8_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(9) Had a strange experience while drinking (such as seeing something that is not really there) that came back again when you had not been drinking for a while? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ9" id='rbAlcoholQ9_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ9" id='rbAlcoholQ9_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ9" id='rbAlcoholQ9_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ9" id='rbAlcoholQ9_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(10) Lost friends because of your drinking? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ10" id='rbAlcoholQ10_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ10" id='rbAlcoholQ10_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ10" id='rbAlcoholQ10_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ10" id='rbAlcoholQ10_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(11) Become nervous or had the shakes after having sobered up? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ11" id='rbAlcoholQ11_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ11" id='rbAlcoholQ11_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ11" id='rbAlcoholQ11_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ11" id='rbAlcoholQ11_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(12) Tried to commit suicide while drunk? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ12" id='rbAlcoholQ12_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ12" id='rbAlcoholQ12_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbAlcoholQ12" id='rbAlcoholQ12_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbAlcoholQ12" id='rbAlcoholQ12_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>OTHER DRUGS (FVOD)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>(1) Taken drugs to improve your thinking and feeling?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ1" id='rbOtherDrugsQ1_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ1" id='rbOtherDrugsQ1_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ1" id='rbOtherDrugsQ1_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ1" id='rbOtherDrugsQ1_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(2) Taken drugs to help you feel better about a problem?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ2" id='rbOtherDrugsQ2_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ2" id='rbOtherDrugsQ2_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ2" id='rbOtherDrugsQ2_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ2" id='rbOtherDrugsQ2_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(3) Taken drugs to become more aware of your senses (e.g. sight, hearing, touch, etc.)?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ4" id='rbOtherDrugsQ4_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ4" id='rbOtherDrugsQ4_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ4" id='rbOtherDrugsQ4_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ4" id='rbOtherDrugsQ4_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(4) Taken drugs to imporive your enjoyment of sex?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ5" id='rbOtherDrugsQ5_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ5" id='rbOtherDrugsQ5_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ5" id='rbOtherDrugsQ5_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ5" id='rbOtherDrugsQ5_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(5) Taken drugs to help forget that you feel helpless or unworthy?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ6" id='rbOtherDrugsQ6_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ6" id='rbOtherDrugsQ6_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ6" id='rbOtherDrugsQ6_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ6" id='rbOtherDrugsQ6_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(6) Taken drugs to forget school, work, or family pressures?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ7" id='rbOtherDrugsQ7_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ7" id='rbOtherDrugsQ7_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ7" id='rbOtherDrugsQ7_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ7" id='rbOtherDrugsQ7_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(7) Gotten into trouble in schoo, at home, at work or with the law because of drugs?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ8" id='rbOtherDrugsQ8_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ8" id='rbOtherDrugsQ8_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ8" id='rbOtherDrugsQ8_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ8" id='rbOtherDrugsQ8_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(8) Gotten really stoned or wiped out on drugs (more than just high)?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ9" id='rbOtherDrugsQ9_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ9" id='rbOtherDrugsQ9_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ9" id='rbOtherDrugsQ9_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ9" id='rbOtherDrugsQ9_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(9) Tried to talk a doctor into giving you some prescription drug (e.g. diet pills, pain killers, etc.)?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ10" id='rbOtherDrugsQ10_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ10" id='rbOtherDrugsQ10_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ10" id='rbOtherDrugsQ10_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ10" id='rbOtherDrugsQ10_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>
                    <tr>
                        <td className='w-750'>(10) Spent your spare time in drug-related activities (e.g. buying, seeling, taking, etc.)?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ11" id='rbOtherDrugsQ11_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ11" id='rbOtherDrugsQ11_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ11" id='rbOtherDrugsQ11_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ11" id='rbOtherDrugsQ11_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>
                    <tr>
                        <td className='w-750'>(11) Used drugs and alcohol at the same time?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ12" id='rbOtherDrugsQ12_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ12" id='rbOtherDrugsQ12_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ12" id='rbOtherDrugsQ12_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ12" id='rbOtherDrugsQ12_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(12) Continued to take a drug or drugs in order to avoid the pain of withdrawal?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ13" id='rbOtherDrugsQ13_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ13" id='rbOtherDrugsQ13_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ13" id='rbOtherDrugsQ13_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ13" id='rbOtherDrugsQ13_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(13) Felt your drug use has kept you from getting what you want out of life?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ14" id='rbOtherDrugsQ14_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ14" id='rbOtherDrugsQ14_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ14" id='rbOtherDrugsQ14_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ14" id='rbOtherDrugsQ14_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(14) Been accepted into a treatment program because of drug use?</td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ3" id='rbOtherDrugsQ3_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ3" id='rbOtherDrugsQ3_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ3" id='rbOtherDrugsQ3_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ3" id='rbOtherDrugsQ3_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(15) Gone to school after drinking or using drugs? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ15" id='rbOtherDrugsQ15_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ15" id='rbOtherDrugsQ15_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ15" id='rbOtherDrugsQ15_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ15" id='rbOtherDrugsQ15_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>(16) Drink or used drugs away from home? </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ16" id='rbOtherDrugsQ16_0' className='add-only' value="0" /> Never</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ16" id='rbOtherDrugsQ16_1' className='add-only' value="1" /> Once OR Twice</td>
                        <td className='w-150'><input type="radio" name="rbOtherDrugsQ16" id='rbOtherDrugsQ16_2' className='add-only' value="2" /> Several Times</td>
                        <td className='w-200'><input type="radio" name="rbOtherDrugsQ16" id='rbOtherDrugsQ16_3' className='add-only' value="3" /> Repeatedly</td>
                    </tr>

                </table>








            </div>
        </form>

    )
}